// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".btnBox[data-v-9dbd5ece] {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding-bottom: 50px;\n}", ""]);
// Exports
module.exports = exports;
